<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" class="ma-2" icon dark v-bind="attrs" v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in addableElements" :key="index">
        <v-list-item-title @click="$emit('addElement', item)">
          {{ $t(`management.mentorship.feedback.edit.element.${item}`) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    addableElements: {
      type: Array,
      required: true,
    },
  },
};
</script>
